/**
 * "Descartar o que foi preenchido?" — C-91 (Gabriel, 18/10/2026). Aparece por cima do
 * formulário quando a pessoa fecha (×, Esc, Cancelar, clique fora) com algo preenchido.
 * Esc = "Continuar editando", a saída segura (`usePopup`). Estado em
 * `useFecharComConfirmacao`.
 */
import { usePopup } from '@/hooks/usePopup';

interface Props {
  onContinuar: () => void;
  onDescartar: () => void;
}

export function ConfirmarDescarte({ onContinuar, onDescartar }: Props) {
  const ref = usePopup<HTMLDivElement>({ aoFechar: onContinuar });
  return (
    // O clique não sobe ao overlay do formulário, que fecharia (ou perguntaria) de novo.
    <div
      className="fixed inset-0 z-[2100] flex items-center justify-center bg-black/60 p-4"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        ref={ref}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirmar-descarte-titulo"
        aria-describedby="confirmar-descarte-texto"
        tabIndex={-1}
        className="w-full max-w-sm rounded-xl border border-jf-border bg-jf-surface p-4 focus:outline-none"
      >
        <h3 id="confirmar-descarte-titulo" className="text-sm font-bold text-white">
          Descartar o que foi preenchido?
        </h3>
        <p id="confirmar-descarte-texto" className="mt-1 text-xs text-jf-muted">
          O que você preencheu nesta janela será perdido.
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            onClick={onContinuar}
            autoFocus
            className="rounded-md bg-jf-yellow px-3 py-1.5 text-xs font-bold text-jf-bg"
          >
            Continuar editando
          </button>
          <button
            type="button"
            onClick={onDescartar}
            className="rounded-md border border-red-500/50 px-3 py-1.5 text-xs font-bold text-red-300 hover:bg-red-500/10"
          >
            Descartar
          </button>
        </div>
      </div>
    </div>
  );
}
